import { useMemo } from "react"

import { useVariantSettings } from "~/hooks/useVariantTableHooks"

const shouldBeShownFallback = {
  bufferType: "serviceLevel",
  bufferValue: 1.4,
  totalLeadTimeDays: 30,
  // Null, not a number: "not supplied by the source system", so consumers infer (SUP-423).
  productionLeadTimeDays: null,
  transportLeadTimeDays: null,
  purchaseIntervalDays: 35,
  colliSize: 1,
  minimumOrderQuantity: 1,
  hasSkuMoqData: false,
  secondaryMoq: 1,
  productType: null,
  activatedFrom: null,
  demandActivatedFrom: null,
  activatedUntil: null,
  noosStartDate: null,
  phasingOutFrom: null,
  lifecycleStatus: null,
  ignore: false,
  userId: null,
  preferredVendorId: null,
}

export function useGetVariantSettings(enabled: boolean) {
  const { data: settings, isLoading } = useVariantSettings(enabled)

  const getSettings = useMemo(() => {
    return (variantId: string) => settings?.get(variantId) ?? shouldBeShownFallback
  }, [settings, isLoading])

  return {
    getSettings,
    isLoading: isLoading,
  }
}
